// Bump when `useRunMigrationsMutation` semantics change in a way that invalidates
// every existing fingerprint (e.g. so stuck dev databases get reset by the new
// drop-and-replay path).
export const MIGRATIONS_CACHE_VERSION = 2;

/** Storage key for the persisted migrations JSON snapshot (see `DatabaseMigrationsProvider`). */
export function getMigrationsFingerprintStorageKey(cacheKey: string) {
  return `hanMigrationsCache:v${MIGRATIONS_CACHE_VERSION}:${cacheKey}`;
}
